import React from "react";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as RiIcons from "react-icons/ri";
import CerrarSesion from "./CerrarSesion";
import Cookies from "universal-cookie";
import { DisabledByDefault } from "@mui/icons-material";
import CryptoJS from "crypto-js";

const secretKey = "clave_secreta_segura";

// 🔐 Función URL Safe
const encryptAES_UrlSafe = (text) => {
  if (!text) return "";

  const cipherText = CryptoJS.AES.encrypt(text, secretKey).toString();
  return cipherText.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

export const SidebarDataInstitucion = () => {
  const cookies = new Cookies();

  const nombre = cookies.get("Nombre") || "Cargando...";
  const id = cookies.get("id") || "";
  const hash = cookies.get("hash") || "";

  // (si lo necesitas en rutas futuras)
  const correoCifradoUrlSafe = encryptAES_UrlSafe(hash);

  return [
    {
      title: <span style={{ fontSize: "12px" }}>{nombre}</span>,
      icon: <IoIcons.IoIosPerson />,
    },
    {
      title: "Información General",
      path: "/Instituciones",
      icon: <AiIcons.AiFillHome />,
      iconClosed: <RiIcons.RiArrowDownSFill />,
      iconOpened: <RiIcons.RiArrowUpSFill />,
      subNav: [
        {
          title: "Representante Legal",
          path: "/RepresentanteLegal",
          icon: <IoIcons.IoIosPerson />,
        },
        {
          title: "Gerente",
          path: "/GerenteInstitucion",
          icon: <IoIcons.IoIosPeople />,
        },
        { title: "Sedes", path: "/InfoSedes", icon: <IoIcons.IoIosMap /> },
        {
          title: "Número Trabajadores",
          path: "/CreaTrabajadores",
          icon: <IoIcons.IoIosPeople />,
        },
        {
          title: "Información Servicios",
          path: `/InfoServicios/${id}`,
          icon: <IoIcons.IoIosSearch />,
        },
        {
          title: "Servicios Lab/Imágenes",
          path: "/InfoServiciosModalidad",
        },
        {
          title: "Capacidad Instalada",
          path: "/CreaCapacidad",
          icon: <IoIcons.IoIosDesktop />,
        },
        {
          title: "Documentación soporte",
          path: "/InfoDocumentacion",
          icon: <IoIcons.IoIosDocument />,
        },
      ],
    },
    {
      title: "Solicitudes",
      path: `/Home/${hash}`,
      icon: <IoIcons.IoIosPaper />,
      iconClosed: <RiIcons.RiArrowDownSFill />,
      iconOpened: <RiIcons.RiArrowUpSFill />,
    },
    {
      title: "Indicadores",
      path: "/Indicadores",
      icon: <IoIcons.IoMdList />,
    },
    {
      title: "Modulo OM",
      icon: <AiIcons.AiFillHome />,
      iconClosed: <RiIcons.RiArrowDownSFill />,
      iconOpened: <RiIcons.RiArrowUpSFill />,
      subNav: [
        {
          title: "OM No Agrupadas",
          path: "/OmNoAgrupadas",
          icon: <IoIcons.IoIosRocket />,
        },
        {
          title: "OM Agrupadas",
          path: "/OmAgrupadas",
          icon: <IoIcons.IoIosRocket />,
        },
        {
          title: "Resumen OM",
          path: "/ResumenOm",
          icon: <IoIcons.IoIosRocket />,
        },
        {
          title: "OM Solucionadas",
          path: "/OMsolucionada",
          icon: <IoIcons.IoIosRocket />,
        },
      ],
    },
    {
      title: "Repositorio de Información",
      path: "/InfoRepositorio",
      icon: <IoIcons.IoMdRecording />,
    },
    {
      title: "",
      path: "/log",
      icon: <CerrarSesion />,
    },
  ];
};
